import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import React from 'react';
import { useSelector } from 'react-redux';

const StyledButton = styled(Button)(({custompadding}) => ({
  padding:custompadding || '5px 25px',
  width: '110px',
  borderRadius: '5px',
  color: '#727484',
  textTransform: 'none !important',
  marginRight: '20px',
  borderColor: '#D6D8E5',
  letterSpacing: 'normal',
  '&:hover': {
    background: 'none',
    borderColor: '#D6D8E5',
  },
}));

const StyledCancelButton = ({
  label,
  onClickFn,
  customWidth,
  customFontFam,
  custompadding
}) => {
  const userDomain = useSelector((state) => state?.selectedDomain?.userDomain) || '';

  const buttonStyles = {};

  if (customWidth) {
    buttonStyles.width = `${customWidth}px`;
  }

  if (customFontFam) {
    buttonStyles.fontFamily = customFontFam;
  }

  return (
    <StyledButton
      onClick={onClickFn}
      variant='outlined'
      className={userDomain && !customFontFam && `${userDomain}_semi_bold_font letter-spacing-custom`}
      style={buttonStyles}
      custompadding={custompadding}
      >
      {label}
    </StyledButton>
  );
};

export default StyledCancelButton;
